 
// @ts-nocheck
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import */
 
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { PageNotFound } from 'app/components/page-not-found';
import { SystemHeader, SystemIcon } from 'app/components/shared/system-header';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasReadAccessToMasterConfigSubSystem } from 'selectors';
import { SettlementTransactions } from './settlement-transactions';
import { Banks } from './banks';
import { OrganisationBanks } from './organisation-banks';
import { FinancialAccounts } from './financial-accounts';
const Settlements: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);
  const intl = useIntl();
  const canViewBanks = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'Banks')
  );
   const canViewOrganisationBanks = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'OrganisationBanks')
  );
    const canViewFinancialAccounts = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'FinancialAccounts')
  );
    const canViewSettlementTransactions = useTypedSelector(state =>
    hasReadAccessToMasterConfigSubSystem(state, 'SettlementTransactions')
  );
  const getInitialRoute = () => {
     if (canViewBanks) {
      return `${baseURL}/Banks`;
    }
     if (canViewOrganisationBanks) {
      return `${baseURL}/OrganisationBanks`;
    }
     if (canViewFinancialAccounts) {
      return `${baseURL}/FinancialAccounts`;
    }
    if (canViewSettlementTransactions) {
      return `${baseURL}/settlementTransactions`;
    }

    return `${baseURL}/Banks`;
  };

  return (
    <>
      <SystemHeader
        headerTitle={intl.formatMessage({ id: 'Settlements' })}
        headerIcon={SystemIcon.Settlements}
      />

      <Switch>
        <Redirect from={baseURL} exact to={getInitialRoute()} />

        <Route path={`${baseURL}/Banks`}>
          {canViewBanks ? <Banks /> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/OrganisationBanks`}>
          {canViewOrganisationBanks ? <OrganisationBanks /> : <NotAuthorized />}
        </Route>
       <Route path={`${baseURL}/FinancialAccounts`}>
          {canViewFinancialAccounts ? <FinancialAccounts /> : <NotAuthorized />}
        </Route>
          <Route path={`${baseURL}/settlementTransactions`}>
          {canViewSettlementTransactions ? <SettlementTransactions /> : <NotAuthorized />}
        </Route>
        <Route path="/">
          <PageNotFound />
        </Route>
      </Switch>
    </>
  );
};

export { Settlements };
